module.exports = __webpack_public_path__ + "media/images/pic/brodno/team/administrative/katarzyna-dolecka-4c8e9184de66b90941676757cb984708.webp";